import React from "react";

interface IconProps {
  color?: string;
  size?: number;
}

const HideAlt: React.FC<IconProps> = ({ color = "#09090B", size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.99999 11.6667C7.63065 11.6667 8.20665 11.598 8.73199 11.4794L7.56065 10.308C7.37865 10.322 7.19399 10.3334 6.99999 10.3334C3.43265 10.3334 2.05065 7.76935 1.71599 7.00002C1.96728 6.43923 2.30668 5.92225 2.72132 5.46869L1.78932 4.53669C0.763986 5.64802 0.375319 6.76735 0.367986 6.78935C0.321999 6.92626 0.321999 7.07445 0.367986 7.21135C0.381986 7.25535 1.91132 11.6667 6.99999 11.6667ZM6.99999 2.33335C5.77532 2.33335 4.76932 2.59735 3.93065 2.98735L1.47132 0.528687L0.528653 1.47135L12.5287 13.4714L13.4713 12.5287L11.2587 10.316C13.0013 9.01535 13.6233 7.23935 13.6327 7.21135C13.6786 7.07445 13.6786 6.92626 13.6327 6.78935C13.618 6.74469 12.0887 2.33335 6.99999 2.33335ZM10.3147 9.37202L8.79465 7.85202C8.92132 7.59202 8.99999 7.30602 8.99999 7.00002C8.99999 5.90602 8.09399 5.00002 6.99999 5.00002C6.69399 5.00002 6.40799 5.07869 6.14865 5.20602L4.94332 4.00069C5.605 3.77363 6.30046 3.66069 6.99999 3.66669C10.5673 3.66669 11.9493 6.23069 12.284 7.00002C12.0827 7.46135 11.5067 8.56135 10.3147 9.37202Z"
      fill={color}
    />
  </svg>
);

export default HideAlt;
